import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from "rxjs";
import { map } from "rxjs/operators";
import { SidePanelBase } from "../../../common/components/side-panel-base.class";
import { SidePanelService } from "../../../common/services/side-panel.service";
import { IssueHistory } from "../../../common/models/issue.model";

@Component({
    selector: 'issue-timeline',
    templateUrl: './issue-timeline.component.html',
    styleUrls: ['./issue-timeline.component.scss'],
    standalone: false
})
export class IssueTimelineComponent extends SidePanelBase implements OnInit, OnDestroy {
    static componentName = "IssueTimelineComponent";

    history: IssueHistory[] = [];

    subscription: Subscription = new Subscription();

    constructor(private service: SidePanelService) { super(); }

    ngOnInit() {
        const data$ = this.service.update().pipe(
            map((data: any) => {
                if (data != null && data.data != null) {
                    const sections = data.data.sections;
                    if (sections != null && sections.length > 0) {
                        this.history = sections[0].componentData as IssueHistory[];
                    }
                }
                return this.history
            })
        ).subscribe(
            (history: IssueHistory[]) => {
                this.history = history.sort((a, b) => {
                    if (a.eventDate < b.eventDate) return -1;
                    if (a.eventDate > b.eventDate) return 1;
                    return 0;
                });
            },
            (error) => { console.error(error); }
        );
        this.subscription.add(data$);
        this.history = this.componentData as IssueHistory[];
    }

    ngOnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
    }
}
